var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagItaly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlagItaly_svg__a",
    width: 40,
    height: 40,
    x: 4,
    y: 4,
    rx: 6.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "FlagItaly_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagItaly_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#FlagItaly_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlagItaly_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009246",
    d: "M3 46h14V2H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F2F1",
    d: "M17 46h14V2H17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE2B37",
    d: "M31 46h14V2H31z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0iMWRvZDJvMmUyYSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiB4PSI0IiB5PSI0IiByeD0iNi42NjciLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxtYXNrIGlkPSJodWR6eW8xd2RiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iIzFkb2QybzJlMmEiLz4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8dXNlIGZpbGw9IiNEOEQ4RDgiIHhsaW5rOmhyZWY9IiMxZG9kMm8yZTJhIi8+CiAgICAgICAgICAgIDxnIG1hc2s9InVybCgjaHVkenlvMXdkYikiPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iIzAwOTI0NiIgZD0iTTAgNDRMMTQgNDQgMTQgMCAwIDB6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzIDIpIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0YxRjJGMSIgZD0iTTE0IDQ0TDI4IDQ0IDI4IDAgMTQgMHoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgMikiLz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjQ0UyQjM3IiBkPSJNMjggNDRMNDIgNDQgNDIgMCAyOCAweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAyKSIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgFlagItaly as ReactComponent };